import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

function useSetProjectId() {
  const [_, setCookies] = useCookies(['projectId']);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const projectId = params.get('projectId');
    if (projectId) {
      setCookies('projectId', projectId, {
        path: '/',
        maxAge: 31536000,
      });
    }
  }, []);
}

export default useSetProjectId;
